import React from 'react'
import 'App.css'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from "./pages/Login";
import Home from "./pages/Home";
import PrivateRouter from './routers/PrivateRouter';
import OrderList from 'pages/OrderList';
import Contactus from 'pages/Contactus';
import ProductList from 'pages/product/ProductList';
import AddProduct from 'pages/product/AddProduct';
import UpdateProduct from 'pages/product/UpdateProduct';

// gallery
import GalleryList from 'pages/gallery/List';
import GalleryAdd from 'pages/gallery/Add';
import GalleryUpdate from 'pages/gallery/Update';

import PromoPopup from 'pages/promo/PromoPopup'


// banner
import BannerList from 'pages/banner/List';
import AddBanner from 'pages/banner/Add';
import UpdateBanner from 'pages/banner/Update';

// Our Team
import CreateBill from 'components/billing/CreateBill';

//users
import UsersList from 'pages/users/UsersList';
import UpdateUser from 'pages/users/UpdateUser';
import ListCustomer from 'pages/customer/ListCustomer';
import UpdateCustomer from 'pages/customer/UpdateCustomer';
import BillList from 'components/billing/BillList';
import BillDetails from 'components/billing/BillDetails';

import VideoList from 'pages/video/List';
import AddVideo from 'pages/video/Add';
import ServicesList from 'pages/services/List';
import AddServices from 'pages/services/Add';
import TestimonialList from 'pages/testimonial/List';
import AddTestimonial from 'pages/testimonial/Add';
import UpdateTestimonial from 'pages/testimonial/Update';
import AchievementList from 'pages/achievement/List';
import AddAchievement from 'pages/achievement/Add';
import UpdateAchievement from 'pages/achievement/Update';

import GiftProductList from 'pages/giftproduct/List';
import AddGiftProduct from 'pages/giftproduct/Add';
import UpdateGiftProduct from 'pages/giftproduct/Update';
import CategoryList from 'pages/category/List';
import AddCategory from 'pages/category/Add';
import UpdateCategory from 'pages/category/Update';
import MainCategoryList from 'pages/main_category/List';
import AddMainCategory from 'pages/main_category/Add';
import UpdateMainCategory from 'pages/main_category/Update';
import SubCategoryList from 'pages/sub_category/List';
import AddSubCategory from 'pages/sub_category/Add';
import UpdateSubCategory from 'pages/sub_category/Update';
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/signin" element={<Login />} />
        <Route path="/" element={<Login />} />
        <Route element={<PrivateRouter />}>
          <Route path="/dashboard" element={<Home />} />
          <Route path="/orderlist" element={<OrderList />} />
          <Route path="/contactus" element={<Contactus />} />
          <Route path="/products" element={<ProductList />} />
          <Route path="/products/add" element={<AddProduct />} />
          <Route path="/products/update/:id" element={<UpdateProduct />} />

          {/* gallery */}
          <Route path="/gallery" element={<GalleryList />} />
          <Route path="/gallery/add" element={<GalleryAdd />} />
          <Route path="/gallery/update/:id" element={<GalleryUpdate />} />

          {/* banner */}
          <Route path="/banner" element={<BannerList />} />
          <Route path="/banner/add" element={<AddBanner />} />
          <Route path="/banner/update/:id" element={<UpdateBanner />} />

          {/* user  */}
          <Route path="/users" element={<UsersList />} />
          <Route path="/users/update/:id" element={<UpdateUser />} />

          {/* billing */}
          <Route path="/billing" element={<CreateBill />} />
          <Route path="/billing-list" element={<BillList />} />
          <Route path="/billing/details/:id" element={<BillDetails />} />

          {/* Customer */}
          <Route path="/customer" element={<ListCustomer />} />
          <Route path="/customer/update/:id" element={<UpdateCustomer />} />

          {/* customer order list — redirect to combined order list */}
          <Route path="/customerorder" element={<Navigate to="/orderlist?type=product" replace />} />
          <Route path="/guestorder" element={<Navigate to="/orderlist?type=gift" replace />} />
          <Route path="/*" element={<h1>No page avaliable</h1>} />

          <Route path="/promousers" element={<PromoPopup />} />
          <Route path="/video" element={<VideoList />} />
          <Route path="/video/add" element={<AddVideo />} />
          <Route path="/services" element={<ServicesList />} />
          <Route path="/services/add" element={<AddServices />} />
          <Route path="/testimonials" element={<TestimonialList />} />
          <Route path="/testimonials/add" element={<AddTestimonial />} />
          <Route path="/testimonials/update/:id" element={<UpdateTestimonial />} />
          <Route path="/achievements" element={<AchievementList />} />
          <Route path="/achievements/add" element={<AddAchievement />} />
          <Route path="/achievements/update/:id" element={<UpdateAchievement />} />

          <Route path="/gift-products" element={<GiftProductList />} />
          <Route path="/gift-products/add" element={<AddGiftProduct />} />
          <Route path="/gift-products/update/:id" element={<UpdateGiftProduct />} />
          <Route path="/categories" element={<CategoryList />} />
          <Route path="/categories/add" element={<AddCategory />} />
          <Route path="/categories/update/:id" element={<UpdateCategory />} />
          <Route path="/main-categories" element={<MainCategoryList />} />
          <Route path="/main-categories/add" element={<AddMainCategory />} />
          <Route path="/main-categories/update/:id" element={<UpdateMainCategory />} />
          <Route path="/sub-categories" element={<SubCategoryList />} />
          <Route path="/sub-categories/add" element={<AddSubCategory />} />
          <Route path="/sub-categories/update/:id" element={<UpdateSubCategory />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
